/**
 * @fileoverview Contains all type declarations related to OTLocation model and
 * state.
 */

import {type GuidType} from '../../../../values/generic-type-definitions'
import LoadingState from '../../../../values/loading-state-enum'
import {type OTLocationsState} from './ot-locations-state'

/**
 * Enum for status field of OTLocation
 */
export enum OTLocationStatus {
    /**
     * Location is active in Basal Ganglia
     */
    ACTIVE = 'active',
    /**
     * Location is inactive in Basal Ganglia
     */
    INACTIVE = 'inactive',
    /**
     * Location is removed from Basal Ganglia
     */
    REMOVED = 'removed',
}

/**
 * Represents Location from OT inventory service
 */
export interface OTLocation {
    /**
     * Identifier for OTLocation
     */
    id: GuidType
    /**
     * IMO ID or code of Location
     */
    customerCode: string
    /**
     * Equivalent to description of Location
     */
    name: string
    /**
     * Equivalent to type of Location
     */
    type: string
    /**
     * Status of OTLocation
     */
    status: OTLocationStatus
    /**
     * Creation timestamp of OTLocation in OT inventory service
     */
    createdAt: Date
    /**
     * Update timestamp of OTLocation in OT inventory service
     */
    updatedAt: Date
    /**
     * Aggregated count of hardware asset associated with OTLocation
     */
    hardwareAssetCount: number
    /**
     * System-generated code with suffix of 3 digits e.g. ABC-001
     */
    code: string
    /**
     * Number of potentially detected assets in OTLocation
     */
    assetDetectionCount: number
}

/**
 * Redux state value for OTLocations
 */
export interface OTLocationsReduxState {
    /**
     * Loading state for OTLocations
     */
    loadingState: LoadingState
    /**
     * Data for OTLocations
     */
    data: OTLocation[]
}

/**
 * Initial redux state value for OTLocation
 */
export const DEFAULT_OT_LOCATIONS_STATE: OTLocationsState = {
    loadingState: LoadingState.NotPopulated,
    data: [],
    filteredData: [],
    filter: '',
    reportUrl: null,
    showGenerateReportPopup: false,
    createReportError: '',
    isErrorOpen: false,
    potentialOtCountMap: null,
}
